import { render, staticRenderFns } from "./upload-list.vue?vue&type=template&id=63220b74"
import script from "./upload-list.vue?vue&type=script&lang=js"
export * from "./upload-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports